import { render, staticRenderFns } from "./MissingBankCCsAfterOBKMigrationPopup.vue?vue&type=template&id=4628d63a&scoped=true"
import script from "./MissingBankCCsAfterOBKMigrationPopup.vue?vue&type=script&lang=js"
export * from "./MissingBankCCsAfterOBKMigrationPopup.vue?vue&type=script&lang=js"
import style0 from "./MissingBankCCsAfterOBKMigrationPopup.vue?vue&type=style&index=0&id=4628d63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628d63a",
  null
  
)

export default component.exports